module.exports = __webpack_public_path__ + "img/u236.ec0caaaa.svg";